import { useQuery } from '@apollo/client';
import { GET_CALLS_BY_HOUR_PST } from '../graphql/queries';

export interface CallsGroupedByHourPST {
  callHour: string;
  callCount: number;
}

interface UseCallsGroupedByHourPSTProps {
  startDate: Date;
  endDate: Date;
  agentId?: string;
  minDurationSecs?: number;
  maxDurationSecs?: number;
  callDirection?: 'incoming' | 'outgoing';
}

export const useCallsGroupedByHourPST = ({
  startDate,
  endDate,
  agentId,
  minDurationSecs,
  maxDurationSecs,
  callDirection,
}: UseCallsGroupedByHourPSTProps) => {
  const { loading, error, data } = useQuery(GET_CALLS_BY_HOUR_PST, {
    variables: {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      ...(agentId && { agentId }),
      minDurationSecs,
      maxDurationSecs,
      callDirection,
    },
  });

  return {
    loading,
    error,
    data: data?.getCallsByHourPST as CallsGroupedByHourPST[] | undefined,
  };
};
